const dropzone = {
  title: "DropZone",
  panel: {
    uploadFiles: "Dateien hochladen...",
    myUploads_zero: "Allgemeine Ablage",
    myUploads_one: "Allgemeine Ablage ({{count}})",
    myUploads_other: "Allgemeine Ablage ({{count}})",
    empty: "Keine Dateien vorhanden",
    clientUploads_zero: "Ablage zur Kund:in",
    clientUploads_one: "Ablage zur Kund:in ({{count}})",
    clientUploads_other: "Ablage zur Kund:in ({{count}})",
    uploadsFromClient_zero: "Uploads von Kund:in",
    uploadsFromClient_one: "Uploads von Kund:in ({{count}})",
    uploadsFromClient_other: "Uploads von Kund:in ({{count}})",
  },
  upload: {
    success: "{{fileName}} erfolgreich hochgeladen",
    successMultiple: "{{count}} Dateien erfolgreich hochgeladen",
    error: "{{fileName}} konnte nicht hochgeladen werden",
    errorMultiple: "{{count}} Dateien konnten nicht hochgeladen werden",
    fileTooLarge: "{{fileName}} überschreitet die maximale Größe",
    fileTooLargeMultiple: "{{count}} Dateien überschreiten die maximale Größe",
    invalidFileType: "{{fileName}}: Nur {{types}} sind erlaubt",
    invalidFileTypeMultiple: "{{count}} Dateien haben einen ungültigen Typ (Nur {{types}} erlaubt)",
    conversionFailed: "{{fileName}} konnte nicht in PDF umgewandelt werden",
    attachmentConversionFailed: "{{fileName}}: Ein Anhang in der E-Mail kann nicht in PDF umgewandelt werden",
  },
  uploadFormat: {
    title: "Datei hochladen",
    fileEntry: "Die Datei <strong>{{name}} ({{type}}, {{size}})</strong> soll hochgeladen werden.",
    notice: "Bitte gewünschte Variante bestätigen. Auswahl für alle Dokumente gültig.",
    uploadOriginal: "Originaldatei hochladen",
    convertToPdf: "Zu PDF konvertieren und hochladen",
  },
  fileList: {
    previewNotImplemented: "Vorschau für diese Ablage noch nicht verfügbar.",
    previewError: "Fehler beim Laden der Vorschau",
    previewNotReady: "Vorschau wird noch erstellt. Bitte versuchen Sie es später erneut.",
    previewFailed: "Vorschau konnte nicht erstellt werden.",
    uploading: "{{fileName}} wird hochgeladen",
    selectFile: "{{fileName}} auswählen",
    openFileActions: "Aktionen für {{fileName}} öffnen",
    deleteSuccess: '"{{fileName}}" erfolgreich gelöscht',
    deleteError: 'Fehler beim Löschen von "{{fileName}}"',
    downloadError: "Fehler beim Herunterladen der Datei",
    renameSuccess: '"{{fileName}}" erfolgreich umbenannt',
    renameError: 'Fehler beim Umbenennen von "{{fileName}}"',
    createCaseNoteSuccess: 'Aktenvermerk für "{{fileName}}" erfolgreich erstellt',
    createCaseNoteError: 'Fehler beim Erstellen des Aktenvermerks für "{{fileName}}"',
    convertToPdfSuccess: '"{{fileName}}" erfolgreich in PDF umgewandelt',
    convertToPdfError: '"{{fileName}}" konnte nicht in PDF umgewandelt werden',
    convertToPdfNotReady:
      '"{{fileName}}" wird noch verarbeitet und kann erst danach in PDF umgewandelt werden. Bitte versuchen Sie es in wenigen Sekunden erneut.',
    previewOpenInNewTab: "In neuem Tab öffnen",
    previewClose: "Vorschau schließen",
    bulkDownload: "Herunterladen",
    bulkDelete: "Löschen",
    bulkDeleteConfirmTitle: "Dokumente löschen",
    bulkDeleteConfirmText: "Möchten Sie die folgenden Dokumente wirklich löschen?",
    bulkDeleteSuccess: "{{count}} Dokumente erfolgreich gelöscht",
    bulkDeleteSuccess_one: "1 Dokument erfolgreich gelöscht",
    bulkDeleteError: "Fehler beim Löschen von {{count}} Dokumenten",
    bulkMerge: "Zusammenführen",
  },
  merge: {
    dialogTitle: "Dateien zusammenführen",
    infoText:
      "Die folgenden Dateien werden zu einem neuen PDF-Dokument zusammengeführt. Die einzelnen Dateien sind danach nicht mehr verfügbar. Die Reihenfolge der Dokumente im neuen PDF kann hier durch manuelles Sortieren angepasst werden.",
    cancel: "Abbrechen",
    confirm: "In neues PDF zusammenführen",
    dragHandleAria: "Reihenfolge per Drag & Drop ändern",
    rotateAria: "Datei um 90 Grad drehen",
    previewLoading: "Vorschau wird geladen",
    submitting: "Zusammenführen läuft",
    success: "Dateien erfolgreich zu einem PDF zusammengeführt",
    error: "Fehler beim Zusammenführen der Dateien",
  },
  dnd: {
    openPreview: "Vorschau von {{fileName}} öffnen",
    draggableRoleDescription: "verschiebbar",
    moveToClientSuccess: "Dokument zur Kund:in-Ablage verschoben",
    moveToClientError: "Fehler beim Verschieben zur Kund:in-Ablage",
    moveToGeneralSuccess: "Dokument zur allgemeinen Ablage verschoben",
    moveToGeneralError: "Fehler beim Verschieben zur allgemeinen Ablage",
    moveSuccess: "Dokument erfolgreich verschoben",
    moveError: "Fehler beim Verschieben des Dokuments",
    pendingMove: "Wird beim Speichern verschoben",
    cancelMove: "Verschieben rückgängig machen",
    moveFileError: "{{fileName}} konnte nicht verschoben werden",
    zoneCounselor: "Allgemeine Ablage",
    zoneClient: "Ablage zur Kund:in",
    zoneClientSelf: "Uploads von Kund:in",
    zoneCaseNote: "Aktenvermerk",
    zoneAssetInventoryDependants: "Unterlagen zu Unterhaltspflichten",
    zoneAssetInventoryBankStatement: "Kontoauszug",
    zoneAssetInventoryIncome: "Einkommensbelege",
    zoneAssetInventoryExpenses: "Belege der Ausgaben",
    zoneAssetInventoryOwnClaims: "Unterlagen zu den eigenen Forderungen",
    zoneAssetInventoryDomesticRealEstate: "Unterlagen zur Immobilie",
    zoneAssetInventoryForeignRealEstate: "Unterlagen zur Immobilie im Ausland",
    zoneAssetInventoryBuildingSavingsContracts: "Schreiben der Bausparkasse",
    zoneAssetInventorySavingsAccounts: "Sparbuch oder Auszug Sparkonto",
    zoneAssetInventoryLifeInsurances: "Schreiben der Versicherung zur Lebensversicherung",
    zoneAssetInventoryPensionInsurances: "Nachweis über Pensionsvorsorge",
    zoneAssetInventorySecuritiesDepots: "Nachweis über Wertpapiere",
    zoneAssetInventoryCashAndBankAssets: "Unterlagen zum Bankvermögen",
    zoneAssetInventoryVehicles: "Unterlagen zum Fahrzeug",
    zoneAssetInventoryBuildingsOnForeignLand: "Unterlagen zu Bauten auf fremden Grundstücken",
    zoneAssetInventoryTenancyRights: "Mietvertrag und Unterlagen zur Miete",
    zoneAssetInventoryCompanyShares: "Unterlagen zu Firmenbeteiligungen",
    zoneAssetInventoryCooperativeMemberships: "Unterlagen zur Mitgliedschaft bei der Genossenschaft",
    zoneAssetInventoryOtherPropertyRights: "Unterlagen zu den sonstigen Vermögensrechten",
    zoneAssetInventoryDonations: "Unterlagen zu den Vermögensauseinandersetzungen",
    srInstructions:
      "Zum Öffnen der Vorschau Eingabetaste drücken. Zum Aufnehmen der Datei Leertaste drücken. Mit den Pfeiltasten zwischen den möglichen Ablagen wechseln. Zum Ablegen erneut Eingabetaste oder Leertaste drücken, Escape bricht ab.",
    srPickedUp: "{{fileName}} aufgenommen",
    srOverZone: "{{fileName}} über {{zone}}",
    srNotOverZone: "{{fileName}} über keiner Ablage",
    srDroppedInZone: "{{fileName}} in {{zone}} abgelegt",
    srDropCancelled: "Verschieben von {{fileName}} abgebrochen",
  },
  uploadLink: {
    activate: "Kundenupload aktivieren",
    confirmActivateTitle: "Kundenupload aktivieren?",
    confirmActivateText:
      "Es wird ein Upload-Link erzeugt, über den die Kund:in Dateien hochladen kann. Sie können den Link anschließend kopieren und der Kund:in zur Verfügung stellen.",
    confirmActivateConfirm: "Aktivieren",
    copyLink: "Upload-Link kopieren",
    linkCopied: "Upload-Link in die Zwischenablage kopiert",
    copyFailed: "Upload-Link konnte nicht kopiert werden",
    activateSuccess: "Kundenupload aktiviert",
    activateError: "Kundenupload konnte nicht aktiviert werden",
    deactivate: "Kundenupload sperren",
    confirmDeactivateTitle: "Kundenupload sperren?",
    confirmDeactivateText:
      "Wenn Sie den Upload sperren, kann die Kund:in über den Upload-Link keine Dateien mehr hochladen. Die Sperre lässt sich jederzeit wieder aufheben.",
    confirmDeactivateConfirm: "Sperren",
    deactivateSuccess: "Kundenupload gesperrt",
    deactivateError: "Kundenupload konnte nicht gesperrt werden",
  },
};

export default dropzone;
